<div class="text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Add Node</h4>
    <i
      style="z-index: 1"
      class="bi bi-x-lg text-danger"
      color="warn"
      (click)="onClose()"
      title="Close"
    ></i>
  </div>

  <div class="modal-body" style="max-height:75vh; overflow: auto;">
    <form
      spellcheck="false"
      autocomplete="off"
      [formGroup]="addNodeForm"
      (ngSubmit)="onSubmit(addNodeForm)"
      style="padding: 6px; margin-left: 12px"
    >
      <mat-form-field appearance="fill" class="me-1" style="width: 48%">
        <mat-label>Select Node Type</mat-label>
        <mat-select formControlName="nodeType" style="font-size: 14px">
          <mat-option
            *ngFor="let type of nodeTypeList"
            value="{{ type.value }}"
            >{{ type.name }}</mat-option
          >
          <!--<mat-option value="3">Workstation</mat-option>
       <mat-option value="0">Head Node</mat-option>
      <mat-option value="1">Compute Node</mat-option>
      <mat-option value="2">License Server</mat-option>
      <mat-option value="3">VPN Server</mat-option>
      <mat-option value="5">Workstore</mat-option>
      <mat-option value="6">Compute Node + Workstore</mat-option>
      <mat-option value="7">Head + Compute + Workstore Node</mat-option>
      <mat-option value="8">Head + Workstore Node</mat-option>
      <mat-option value="9">Gpu + Compute</mat-option> -->
        </mat-select>
      </mat-form-field>

      <ng-container>
        <mat-form-field class="me-1" style="width: 48%">
          <mat-label>Select Deployment</mat-label>
          <mat-select
            class="mat-mdc-form-field-flex"
            formControlName="deploymentName"
            (selectionChange)="getConnectorType($event.value)"
            style="font-size: 14px"
          >
            <mat-option
              *ngFor="let depName of deployments"
              value="{{ depName }}"
            >
              {{ depName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="me-1" style="width: 48%">
          <mat-label>Enter Node Name</mat-label>
          <input
            matInput
            class="mat-mdc-form-field-flex"
            title="Enter Node Name"
            formControlName="computerName"
            placeholder="Node Name"
            style="font-size: 14px"
          />
          <mat-error
            *ngIf="
              addNodeForm.get('computerName').touched &&
              addNodeForm.get('computerName').errors?.required
            "
            style="font-size: smaller"
          >
            Enter Computer Name
          </mat-error>
        </mat-form-field>

        <mat-form-field class="me-1" style="width: 48%">
          <mat-label>Select Cloud Provider</mat-label>
          <mat-select
            formControlName="cloudProviders"
            (selectionChange)="cloudProviderChanged($event.value)"
            style="font-size: 14px"
          >
            <mat-option
              *ngFor="let cloud of cloudProvidersList"
              value="{{ cloud }}"
            >
              {{ cloud }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="me-1" style="width: 48%">
          <mat-label>Node Size</mat-label>
          <mat-select formControlName="nodeSize" style="font-size: 14px">
            <mat-option
              *ngFor="let config of nodeConfigNames"
              value="{{ config }}"
              >{{ config }}</mat-option
            >
          </mat-select>
        </mat-form-field>

        <mat-form-field style="width: 48%">
          <mat-label>Select Platform</mat-label>
          <mat-select formControlName="platformType" style="font-size: 14px">
            <mat-option value="LINUX">LINUX</mat-option>
            <mat-option value="WINDOWS">WINDOWS</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          class="me-1"
          style="width: 48%"
          *ngIf="isKvmDep == true"
        >
          <mat-label>Select Provision Source</mat-label>
          <mat-select
            formControlName="provisionSource"
            (selectionChange)="provisionSourceChange($event.value)"
            style="font-size: 12px"
          >
            <mat-option
              *ngFor="let provSource of nodeProvisionSourceArray"
              [value]="provSource"
            >
              {{ provSource }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          class="me-1"
          style="width: 48%"
          *ngIf="isKvmDep == true"
        >
          <mat-label>Disk Image Name</mat-label>
          <mat-select formControlName="image" style="font-size: 14px">
            <mat-option
              *ngFor="let disks of provisionSourceList"
              [value]="disks"
            >
              {{ disks }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="
              addNodeForm.get('image').touched &&
              addNodeForm.get('image').errors?.required
            "
          >
            Enter Disk Image Name
          </mat-error>
        </mat-form-field>

        <mat-form-field
          class="me-1"
          style="width: 48%"
          *ngIf="refDiskSelected == false && isKvmDep == true"
        >
          <mat-label>Enter Number of Nodes</mat-label>
          <input
            matInput
            title="Enter Number of Nodes"
            formControlName="numofnodes"
            placeholder="Number of nodes"
            style="font-size: 12px"
          />
          <mat-error
            *ngIf="
              addNodeForm.get('numofnodes').touched &&
              addNodeForm.get('numofnodes').errors?.required
            "
          >
            Enter Number of Nodes
          </mat-error>
        </mat-form-field>

        <mat-form-field
          class="me-1"
          style="width: 48%"
          *ngIf="refDiskSelected == true && isKvmDep == true"
        >
          <mat-label>Select Storage Domain</mat-label>
          <mat-select formControlName="storageDomain" style="font-size: 12px">
            <mat-option
              *ngFor="let stDom of storageDomainsList"
              value="{{ stDom?.name }}"
            >
              {{ stDom?.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="me-1" style="width: 48%">
          <mat-label>Disk Type</mat-label>
          <input
            matInput
            title="Enter Disk Type"
            formControlName="osDiskType"
            placeholder="Enter Disk Type"
            style="font-size: 14px"
          />
          <mat-error
            *ngIf="
              addNodeForm.get('osDiskType').touched &&
              addNodeForm.get('osDiskType').errors?.required
            "
          >
            Enter Disk Type
          </mat-error>
        </mat-form-field>

        <mat-form-field class="me-1" style="width: 48%">
          <mat-label>Private IP Address for the node</mat-label>
          <input
            matInput
            title="Private IP Address for the node"
            formControlName="internalIp"
            placeholder="Internal IP Address"
            style="font-size: 14px"
          />
          <mat-error
            *ngIf="
              addNodeForm.get('internalIp').touched &&
              addNodeForm.get('internalIp').errors?.required
            "
          >
            Required
          </mat-error>
          <mat-error
            *ngIf="
              addNodeForm.get('internalIp').touched &&
              addNodeForm.get('internalIp').errors?.pattern
            "
          >
            Invalid IP.
          </mat-error>
        </mat-form-field>

        <mat-form-field class="me-1" style="width: 48%">
          <mat-label>Public IP Address for the node</mat-label>
          <input
            matInput
            title="Public IP Address for the node"
            formControlName="externalIp"
            placeholder="External IP Address"
            style="font-size: 14px"
          />
          <mat-error
            *ngIf="
              addNodeForm.get('externalIp').touched &&
              addNodeForm.get('externalIp').errors?.required
            "
          >
            Required
          </mat-error>
          <mat-error
            *ngIf="
              addNodeForm.get('externalIp').touched &&
              addNodeForm.get('externalIp').errors?.pattern
            "
          >
            Invalid IP.
          </mat-error>
        </mat-form-field>

        <mat-form-field class="me-1" style="width: 48%">
          <mat-label>Allow Connect</mat-label>
          <mat-select formControlName="allowConnect" style="font-size: 14px">
            <mat-option value="true">Enabled</mat-option>
            <mat-option value="false">Disabled</mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <ng-container *ngIf="addNodeForm.get('nodeType').value == '3'">
        <!--<mat-form-field style="width: 48%;">
      <input
             matInput
             title="Private IP Address for the node"
             formControlName="externalIp"
             placeholder="External Ip Address"
             />
      <mat-error
                 *ngIf="
          addNodeForm.get('externalIp').touched &&
          addNodeForm.get('externalIp').errors?.required
        "
                 >
        Required
      </mat-error>
      <mat-error
                 *ngIf="
          addNodeForm.get('externalIp').touched &&
          addNodeForm.get('externalIp').errors?.pattern
        "
                 >
        Invalid IP.
      </mat-error>
    </mat-form-field>-->

        <mat-form-field class="me-1" style="width: 48%">
          <mat-label>Enter MAC Address</mat-label>
          <input
            matInput
            title="Enter MAC Address"
            formControlName="macAddress"
            placeholder="Enter MAC Address"
            style="font-size: 14px"
          />
          <mat-error
            *ngIf="
              addNodeForm.get('macAddress').touched &&
              addNodeForm.get('macAddress').errors?.pattern
            "
          >
            Invalid Mac Address.
          </mat-error>
        </mat-form-field>

        <mat-form-field class="me-1" style="width: 48%">
          <mat-label>Gateway</mat-label>
          <mat-select formControlName="gateway" style="font-size: 12px">
            <mat-option value="" selected>None</mat-option>
            <mat-option
              *ngFor="let gateway of gatewayNames"
              value="{{ gateway }}"
              >{{ gateway }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </ng-container>

      <mat-form-field
        class="me-1"
        style="width: 48%"
        *ngIf="isKvmDep == true"
      >
        <mat-label>Select Host Device</mat-label>
        <mat-select formControlName="hostDevices" style="font-size: 12px">
          <mat-option *ngFor="let hd of hostDevices" value="{{ hd }}">
            {{ hd }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div style="width: 100%; text-align: center">
        <!--<div *ngIf="addNodeForm.get('cloudProviders').value == 'KVM Virtualization'">-->
        <div>
          <mat-checkbox formControlName="skipCloudDeployment">
            {{ skipCloudDeploymentMessage}}
          </mat-checkbox>
        </div>

        <!-- Show note only when checkbox is checked -->
        <label for="" *ngIf="addNodeForm.get('skipCloudDeployment').value === true">
          Note : It is assumed that node is already provisioned
        </label>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">
      Close
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!addNodeForm.valid || isFormSubmitted == true || disableSubmit == true"
      (click)="onSubmit(addNodeForm)"
    >
      Submit
    </button>
  </div>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0)"
  size="default"
  zIndex="1"
  color="var(--s-primary-color)"
  type="ball-spin"
  [fullScreen]="false"
  name="addNode"
  ><p class="pleaseWait text-grey">Please wait ...</p></ngx-spinner
>
